module.exports = __webpack_public_path__ + "media/images/menu_sel_3-e3e32f3671b5d60d5ee9719bcc0e482b.png";